import { getFtPrice, getPercentPrice, getSqftPrice, PRICE_OF_VALUES, PRICE_TYPES } from "../../redux/reducers/utils";
import { calcOverhangSize, const_var, params } from "../../redux/reducers/reducer";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import { convertToTwoDecimalNumber } from "../../redux/reducers/utils";
import { LEAN_TYPE_NUM_TO_STR, LEAN_TYPE_STR_TO_NUM, ManufacturesDefaultDetails } from "../../Constants/constant";

export function getDrawingPricing(selDrawingObj, post_data) {
	let drawingCost = 0;
	if (selDrawingObj?.prices?.length) {
		const price = selDrawingObj?.prices[0].price;
		switch (selDrawingObj.prices[0].price_type) {
			case PRICE_TYPES.DOLLAR:
				drawingCost = price;
				break;
			case PRICE_TYPES.SQFT:
				drawingCost = getSqftPrice(price);
				break;
			case PRICE_TYPES.FT:
				drawingCost = getFtPrice(price);
				break;
			case PRICE_TYPES.PERCENTAGE:
			case "PERCENTAGE":
				selDrawingObj.prices[0].percentage_of = PRICE_OF_VALUES.base_price;
				drawingCost = getPercentPrice({ price, percentage_of: selDrawingObj.prices[0].percentage_of, post_data });
				break;
		}
	} else {
		drawingCost = selDrawingObj.unit_price;
	}
	return drawingCost;
}
export const getDrawingPrice = (drawingObj, post_data) => {
	if (!drawingObj) return 0;
	let price = 0;
	if (drawingObj.name.toLowerCase().includes("none")) {
		return 0;
	} else {
		if (drawingObj.price.length > 0) {
			price = getDrawingPricing(drawingObj, post_data);
		} else {
			price = drawingObj.unit_price;
		}
	}
	return price;
};
const extraItemsFeaturesNonOverhang = (module, val, params, const_var) => {
	const calculatePrice = {
		centerBuilding: () => {
			return 0;
		},
		left: () => {
			let p = 0;
			if (params.add_left_lean && const_var.leanGetDataLeft) {
			}

			if (val.sheet_type == "end" && const_var.leanGetDataLeft.overhang?.end?.length > 0) {
				if (params.m_s_n == 153) {
					let tmp = const_var.isOverhang.end.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
					let sel = const_var.leanGetDataLeft.overhang.end.find((obj) => obj.sheet_name == tmp);
					let selCost = sel?.cost ? sel.cost : 0;
					p += selCost;
				} else {
					let sel = const_var.leanGetDataLeft.overhang.end.find((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
					let selCost = sel?.cost ? sel.cost : 0;
					p += selCost;
				}
			}

			if (val.sheet_type == "side" && const_var.leanGetDataLeft.overhang?.side?.length > 0) {
				if (params.m_s_n == 153) {
					let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
					let sel = const_var.leanGetDataLeft.overhang.side.filter((obj) => obj.sheet_name == tmp);
					let selCost = sel.length != 0 ? sel[0].cost : 0;
					p += selCost;
				} else {
					let sel = const_var.leanGetDataLeft.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
					let selCost = sel.length != 0 ? sel[0].cost : 0;
					p += selCost;
				}
			}

			if (val.sheet_type == "both" && !const_var.leanGetDataLeft?.overhang?.both) {
				let selCost = const_var.leanGetDataLeft.overhang?.both?.cost != undefined ? const_var.leanGetDataLeft.overhang.both.cost : 0;
				p += selCost;
			}
			return p;
		},
		front: () => {
			let p = 0;
			if (params.add_front_lean == true && const_var.leanGetDataFront) {
				if (val.sheet_type == "end" && const_var.leanGetDataFront.overhang?.end?.length > 0) {
					if (params.m_s_n == 153) {
						let tmp = const_var.isOverhang.end.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
						let sel = const_var.leanGetDataFront.overhang.end.filter((obj) => obj.sheet_name == tmp);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					} else {
						let sel = const_var.leanGetDataFront.overhang.end.filter((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					}
				}
				if (val.sheet_type == "side" && const_var.leanGetDataFront.overhang?.side?.length > 0) {
					if (params.m_s_n == 153) {
						let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
						let sel = const_var.leanGetDataFront.overhang.side.filter((obj) => obj.sheet_name == tmp);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					} else {
						let sel = const_var.leanGetDataFront.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					}
				}
				if (val.sheet_type == "both" && const_var.leanGetDataFront?.overhang) {
					let selCost = const_var.leanGetDataFront?.overhang?.both?.cost != undefined ? const_var.leanGetDataFront.overhang.both.cost : 0;
					p += selCost;
				}
			}
			return p;
		},
		back: () => {
			let p = 0;
			if (params.add_back_lean == true && const_var.leanGetDataBack) {
				if (val.sheet_type == "end" && const_var.leanGetDataBack.overhang?.end?.length > 0) {
					if (params.m_s_n == 153) {
						let tmp = const_var.isOverhang.end.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
						let sel = const_var.leanGetDataBack.overhang.end.filter((obj) => obj.sheet_name == tmp);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					} else {
						let sel = const_var.leanGetDataBack.overhang.end.filter((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					}
				}
				if (val.sheet_type == "side" && const_var.leanGetDataBack.overhang?.side?.length > 0) {
					if (params.m_s_n == 153) {
						let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
						let sel = const_var.leanGetDataBack.overhang.side.filter((obj) => obj.sheet_name == tmp);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					} else {
						let sel = const_var.leanGetDataBack.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					}
				}
				if (val.sheet_type == "both" && const_var?.leanGetDataBack?.overhang?.both) {
					let selCost = const_var.leanGetDataBack.overhang.both.cost != undefined ? const_var.leanGetDataBack.overhang.both.cost : 0;
					p += selCost;
				}
			}
			return p;
		},
		right: () => {
			let p = 0;
			if (params.add_right_lean == true && const_var.leanGetDataRight) {
				if (val.sheet_type == "end" && const_var.leanGetDataRight.overhang?.end?.length > 0) {
					if (params.m_s_n == 153) {
						let tmp = const_var.isOverhang.end.selected == "1' Overhang on Ends" ? "10'' Overhang on Ends" : const_var.isOverhang.end.selected;
						let sel = const_var.leanGetDataRight.overhang.end.filter((obj) => obj.sheet_name == tmp);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					} else {
						let sel = const_var.leanGetDataRight.overhang.end.filter((obj) => obj.sheet_name == const_var.isOverhang.end.selected);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					}
				}
				if (val.sheet_type == "side" && const_var.leanGetDataRight.overhang?.side?.length > 0) {
					if (params.m_s_n == 153) {
						let tmp = const_var.isOverhang.side.selected == "1' Overhang on Sides" ? "10'' Overhang on Sides" : const_var.isOverhang.side.selected;
						let sel = const_var.leanGetDataRight.overhang.side.filter((obj) => obj.sheet_name == tmp);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					} else {
						let sel = const_var.leanGetDataRight.overhang.side.filter((obj) => obj.sheet_name == const_var.isOverhang.side.selected);
						let selCost = sel.length != 0 ? sel[0].cost : 0;
						p += selCost;
					}
				}
				if (val.sheet_type == "both" && const_var.leanGetDataRight?.overhang?.both) {
					let selCost = const_var.leanGetDataRight.overhang.both.cost != undefined ? const_var.leanGetDataRight.overhang.both.cost : 0;
					p += selCost;
				}
			}

			return p;
		}
	};

	return calculatePrice[module]();
};

const extraItemsFeaturesOverhangDoller = (module, val, params, const_var) => {
	let cost = parseFloat(val.cost);
	let baseCost = 0;

	if (val.name !== "overhang") {
		baseCost = extraItemsFeaturesNonOverhang(module, val, params, const_var);
	}

	if (module === "centerBuilding") {
		let isLeftStraightRoof = params.leanStyle.left !== "gable" ? (params.add_left_lean && Math.floor(params.lean_p_h + params.lean_p_w * (params.b_l_t_r_p / 12)) == params.p_h ? true : false) : false;
		let isRightStraightRoof = params.leanStyle.right !== "gable" ? (params.add_right_lean && Math.floor(params.leanR_p_h + params.leanR_p_w * (params.b_l_t_r_pR / 12)) == params.p_h ? true : false) : false;
		if ((val.hasOwnProperty("sheet_type") && val.sheet_type.toLowerCase().includes("side")) || (val.hasOwnProperty("label") && val.label.toLowerCase().includes("side"))) {
			if (isLeftStraightRoof && isRightStraightRoof) {
				cost = 0;
			} else if (isLeftStraightRoof) {
				cost = parseFloat(cost / 2);
			} else if (isRightStraightRoof) {
				cost = parseFloat(cost / 2);
			}
		}

		const deductCost = () => {
			if (typeof val?.sheet_type === "string" && val.sheet_type.toLowerCase().includes("end")) {
				cost = parseFloat(cost - parseFloat(cost / 2));
			}
			if (typeof val?.sheet_type === "string" && val.sheet_type.toLowerCase().includes("both")) {
				cost = parseFloat(cost - parseFloat(cost / 4));
			}
		};

		if (cost > 0) {
			let isFrontStraightRoof = params.leanStyle.front === "gable" ? params.add_front_lean && params.leanF_p_h === params.p_h && params.leanF_p_w === params.p_w && params.b_l_t_r_pF == params.b_r_p[0] : false;
			let isBackStraightRoof = params.leanStyle.back === "gable" ? params.add_back_lean && params.leanB_p_h === params.p_h && params.leanB_p_w === params.p_w && params.b_l_t_r_pB == params.b_r_p[0] : false;

			if (isFrontStraightRoof && isBackStraightRoof && typeof val?.sheet_type === "string" && val.sheet_type.toLowerCase().includes("both")) {
				cost = parseFloat(cost - parseFloat(cost / 2));
			} else if (isFrontStraightRoof && isBackStraightRoof) {
				cost = 0;
			} else if (isFrontStraightRoof) {
				deductCost();
			} else if (isBackStraightRoof) {
				deductCost();
			}
		}
	}

	return convertToTwoDecimalNumber(parseFloat(cost) + parseFloat(baseCost));
};

const extraItemsFeaturesOverhangPer = (leanType, val, params, const_var, leanToPriceCalc, post_data, t_c) => {
	let priceOfs = val.price_of ?? [];

	let price = 0;

	let basePrice = 0,
		leanPrice = 0,
		endWallPrice = 0,
		sideWallPrice = 0,
		totalWallPrice = 0,
		heightPrice = 0;

	if (leanType == "centerBuilding") {
		const utilityPrice = parseFloat(post_data["building"].utility_price);
		const utilityFrontPrice = parseFloat(post_data["building"].utility_front_price);

		basePrice = parseFloat(post_data["building"].roof_style_price);
		endWallPrice = parseFloat(post_data["building"].front_wall_price) + parseFloat(post_data["building"].back_wall_price);
		sideWallPrice = parseFloat(post_data["building"].left_wall_price) + parseFloat(post_data["building"].right_wall_price);
		totalWallPrice = endWallPrice + sideWallPrice;
		heightPrice = parseFloat(post_data["building"].height_price);

		if (params.p_u_c == true || params.cB_addStorage_check_left == true || params.cB_addStorage_check_right == true) {
			totalWallPrice += utilityPrice;
		}
		if (post_data["building"].utility_front_price != undefined && params.isBreezeway && params.cB_addStorage_check_front) {
			totalWallPrice += utilityFrontPrice;
		}
	} else {
		basePrice = parseFloat(leanToPriceCalc.basePrice ?? 0);
		leanPrice = parseFloat(leanToPriceCalc.leanPrice ?? 0);
		endWallPrice = parseFloat(leanToPriceCalc.endWallPrice ?? 0);
		sideWallPrice = parseFloat(leanToPriceCalc.sideWallPrice ?? 0);
		totalWallPrice = parseFloat(leanToPriceCalc.allWallPrice ?? 0);
		heightPrice = parseFloat(leanToPriceCalc.heightPrice ?? 0);
	}

	if (priceOfs.length) {
		if (priceOfs.includes("full_building_price")) {
			price += parseFloat(t_c ?? 0) + leanPrice;
		}
		if (priceOfs.includes("base_price")) {
			price += basePrice;
		}
		if (priceOfs.includes("height_price")) {
			price += heightPrice;
		}

		if (priceOfs.includes("wall_price")) {
			if (val.label.toLowerCase().includes("end")) {
				price += endWallPrice;
			} else if (val.label.toLowerCase().includes("side")) {
				price += sideWallPrice;
			} else {
				price += totalWallPrice;
			}
		}
		// const leantoExtraItemCheckBoxCost = getLeanToExtraItemCheckboxCost(const_var, params, val);

		let finalCost = (price * val.cost) / 100;
		finalCost = finalCost % 1 == 0 ? finalCost : finalCost.toFixed(2);

		return parseFloat(finalCost);
	}
	return 0;
};

const extraItemsFeaturesOverhangSQFT = (module, val, params, const_var) => {
	const calculatePrice = {
		centerBuilding: () => {
			let p = 0;
			if (Object.keys(const_var.wallsData["center"]).length > 0) {
				p += parseFloat((params.p_w + 1) * params.p_d * val.cost);
				p += parseFloat(params.p_d * params.p_h * val.cost * parseFloat(const_var.wallsData["center"].closedSideWalls));
				p += parseFloat((params.p_h + 1) * params.p_w * val.cost * parseFloat(const_var.wallsData["center"].closedEndWalls));
			}
			return p;
		},
		front: () => {
			let price = 0;
			if (Object.keys(const_var.wallsData["frontLean"]).length > 0 && params.add_front_lean == true) {
				if (const_var.wallsData["frontLean"].closedSideWalls != 0) {
					price += parseFloat(params.leanF_p_d * params.leanF_p_h * val.cost * parseFloat(const_var.wallsData["frontLean"].closedSideWalls));
				}
				if (const_var.wallsData["frontLean"].closedEndWalls != 0) {
					price += parseFloat((params.leanF_p_h + 1) * params.leanF_p_w * val.cost * parseFloat(const_var.wallsData["frontLean"].closedEndWalls));
				}
				price += parseFloat((params.leanF_p_w + 1) * params.leanF_p_d * val.cost);
			}
			return price;
		},
		back: () => {
			let price = 0;
			if (Object.keys(const_var.wallsData["backLean"]).length > 0 && params.add_back_lean == true) {
				if (const_var.wallsData["backLean"].closedSideWalls != 0) {
					price += parseFloat(params.leanB_p_d * params.leanB_p_h * val.cost * parseFloat(const_var.wallsData["backLean"].closedSideWalls));
				}
				if (const_var.wallsData["backLean"].closedEndWalls != 0) {
					price += parseFloat((params.leanB_p_h + 1) * params.leanB_p_w * val.cost * parseFloat(const_var.wallsData["backLean"].closedEndWalls));
				}
				price += parseFloat((params.leanB_p_w + 1) * params.leanB_p_d * val.cost);
			}
			return price;
		},
		left: () => {
			let price = 0;
			if (Object.keys(const_var.wallsData["leftLean"]).length > 0 && params.add_left_lean == true) {
				if (const_var.wallsData["leftLean"].closedSideWalls != 0) {
					price += parseFloat(params.lean_p_d * params.lean_p_h * val.cost * parseFloat(const_var.wallsData["leftLean"].closedSideWalls));
				}
				if (const_var.wallsData["leftLean"].closedEndWalls != 0) {
					price += parseFloat((params.lean_p_h + 1) * params.lean_p_w * val.cost * parseFloat(const_var.wallsData["leftLean"].closedEndWalls));
				}
				price += parseFloat((params.lean_p_w + 1) * params.lean_p_d * val.cost);
			}
			return price;
		},
		right: () => {
			let price = 0;
			if (Object.keys(const_var.wallsData["rightLean"]).length > 0 && params.add_right_lean == true) {
				if (const_var.wallsData["rightLean"].closedSideWalls != 0) {
					price += parseFloat(params.leanR_p_d * params.leanR_p_h * val.cost * parseFloat(const_var.wallsData["rightLean"].closedSideWalls));
				}
				if (const_var.wallsData["rightLean"].closedEndWalls != 0) {
					price += parseFloat((params.leanR_p_h + 1) * params.leanR_p_w * val.cost * parseFloat(const_var.wallsData["rightLean"].closedEndWalls));
				}
				price += parseFloat((params.leanR_p_w + 1) * params.leanR_p_d * val.cost);
			}
			return price;
		}
	};

	return calculatePrice[module]();
};
export const handleInsulationData = (state, action) => {
	const type = action._type;
	const leanType = type.split("Lean")[0];
	const insulation_price_changed = `${leanType}${"_lean_insulation_price_changed"}`;
	if (action.condition == "insulation") {
		state.params.insulation[type].insulationId = action.value;
		if (action.value != 0) state.params.selectedInsulationId = action.value;

		if (state.params.insulation[type].insulationId != 0) {
			state.params.insulation[type].showInsulationOptions = true;
			if (!state.params.insulation[type].fullBuilding) state.params.insulation[type].roofOnly = true;
		} else {
			state.params.insulation[type].showInsulationOptions = false;

			state.const_var.showDefaultInsullation = false;
		}

		const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
	}
	if (action.condition == "custom") {
		state.params.insulation[type].insulationId = action.value == 0 ? (type != undefined ? Object.keys(const_var.insulationJsonLeanTo)[0] : Object.keys(const_var.insulationJson)[0]) : action.value;
		if (action.value != 0) state.params.selectedInsulationId = action.value;

		if (state.params.insulation[type].insulationId != 0) {
			state.params.insulation[type].showInsulationOptions = true;
			state.params.insulation[type].custom = true;
			state.params.insulation[type].fullBuilding = false;
			state.params.insulation[type].roofOnly = false;
		} else {
			state.params.insulation[type].showInsulationOptions = false;

			state.const_var.showDefaultInsullation = false;
		}

		const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
	}
	if (action.condition == "roofOnly") {
		state.params.insulation[type].roofOnly = !state.params.insulation[type].roofOnly;
		state.params.insulation[type].fullBuilding = state.params.insulation[type].roofOnly == true ? false : state.params.insulation[type].fullBuilding;
		state.params.insulation[type].custom = state.params.insulation[type].roofOnly == true || state.params.insulation[type].fullBuilding == true ? false : state.params.insulation[type].custom;
		if (state.params.insulation[type].roofOnly == false) {
			state.params.insulation[type].insulationId = 0;
			state.params.insulation[type].showInsulationOptions = false;
		}
	}
	if (action.condition == "fullBuilding") {
		state.params.insulation[type].fullBuilding = !state.params.insulation[type].fullBuilding;
		state.params.insulation[type].roofOnly = state.params.insulation[type].fullBuilding == true ? false : state.params.insulation[type].roofOnly;
		state.params.insulation[type].custom = state.params.insulation[type].roofOnly == true || state.params.insulation[type].fullBuilding == true ? false : state.params.insulation[type].custom;
		if (state.params.insulation[type].fullBuilding == false) {
			state.params.insulation[type].insulationId = 0;
			state.params.insulation[type].showInsulationOptions = false;
		}
	}

	if (action.condition == "checkBox") {
		if (type == "center") {
			state.params.insulation.center.isCheked = !state.params.insulation.center.isCheked;
			if (state.params.insulation.center.isCheked) {
				state.params.p_i_o = state.params.selectedInsulationId == 0 ? const_var.cbInsulation[0].insulation_id : state.params.selectedInsulationId;
				state.params.insulation.center.insulationId = state.params.p_i_o;
				state.params.selectedInsulationId = state.params.p_i_o;
			} else {
				state.params.p_i_o = 0;
				state.params.insulation.center.insulationId = 0;
			}
			state.params.insulation.center.showInsulationOptions = state.params.insulation.center.isCheked ? true : false;
			state.params.insulation.center.roofOnly = state.params.insulation.center.insulationId !== 0 ? true : false;
			state.params.insulation.center.fullBuilding = state.params.insulation.center.roofOnly ? false : state.params.insulation.center.fullBuilding;
			state.params.insulation.center.custom = state.params.insulation.center.roofOnly || state.params.insulation.center.fullBuilding ? false : state.params.insulation.center.custom;
			state.params.p_r_o = state.params.p_i_o !== 0 ? true : false;
			state.params.p_f_i = state.params.p_r_o ? false : state.params.p_f_i;
			state.params.p_c_i = state.params.p_r_o || state.params.p_f_i ? false : state.params.p_c_i;
			const_var.UpdatedPriceData.insulation_price = undefined;
			const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;

			cuBuilding.cP();
		} else {
			state.params.insulation[type].isCheked = !state.params.insulation[type].isCheked;
			if (state.params.insulation[type].isCheked) {
				state.params.insulation[type].insulationId = state.params.selectedInsulationId == 0 ? const_var.cbInsulation[0].insulation_id : state.params.selectedInsulationId;
				state.params.selectedInsulationId = state.params.insulation[type].insulationId;
			} else {
				state.params.insulation[type].insulationId = 0;
			}
			state.params.insulation[type].showInsulationOptions = state.params.insulation[type].isCheked ? true : false;
			state.params.insulation[type].roofOnly = state.params.insulation[type].insulationId !== 0 ? true : false;
			state.params.insulation[type].fullBuilding = state.params.insulation[type].roofOnly ? false : state.params.insulation[type].fullBuilding;
			state.params.insulation[type].custom = state.params.insulation[type].roofOnly || state.params.insulation[type].fullBuilding ? false : state.params.insulation[type].custom;
		}
	}

	const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
	let isInsulation = Object.keys(state.params.insulation).find((lean) => state.params.insulation[lean].insulationId != 0);

	state.const_var.UpdatedPriceData[insulation_price_changed] = true;
	state.const_var.UpdatedPriceData.insulation_price = undefined;
	state.const_var.UpdatedPriceData.insulation_price_changed = true;

	if (type == "frontLean") cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
	if (type == "leftLean") cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
	if (type == "rightLean") cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
	if (type == "backLean") cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
	return {
		...state,
		action,
		newColor: isInsulation + params.selectedInsulationId + action + state.params.insulation + state.params.insulation[type] + insulation_price_changed + leanType + new Date()
	};
};
export const handleInsulationForData = (state, action) => {
	if (
		ManufacturesDefaultDetails.AMERICAN_STEEL_CARPORTS.id == params.selectedManufactureId &&
		(state.params.p_r_s != 3 ||
			!state.params.p_v_w ||
			(state.params.p_v_w &&
				state.params.p_r_s == 3 &&
				state.params.p_f_w.toLowerCase() == "open" &&
				state.params.p_b_w.toLowerCase() == "open" &&
				state.params.p_l_w.toLowerCase() == "open" &&
				state.params.p_r_w.toLowerCase() == "open"))
	) {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "notAllowInsulationForHorizontalOrRegularRoof";
	} else {
		if (action.isfor == undefined && const_var.a_p_d_a) {
			if (const_var.insulationPriceJson.insulation_wall == undefined) {
				const_var.insulationPriceJson.insulation_wall = {};
			}
			const_var.insulationPriceJson.insulation_wall[action.key] =
				const_var.insulationPriceJson.insulation_wall && const_var.insulationPriceJson.insulation_wall[action.key] && const_var.insulationPriceJson.insulation_wall[action.key] == true ? false : true;

			if (action.key == "full_roof" && (params.cB_addStorage_check_left || params.p_u_c || params.cB_addStorage_check_right)) {
				const_var.insulationPriceJson.insulation_wall["open_roof"] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? "included" : false;
				const_var.insulationPriceJson.insulation_wall["storage_roof"] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? "included" : false;
			}
			if ((action.key == "open_roof" || action.key == "storage_roof") && (params.cB_addStorage_check_left || params.p_u_c || params.cB_addStorage_check_right)) {
				if (const_var.insulationPriceJson.insulation_wall["open_roof"] == true && const_var.insulationPriceJson.insulation_wall["storage_roof"] == true) {
					const_var.insulationPriceJson.insulation_wall["full_roof"] = true;
					const_var.insulationPriceJson.insulation_wall["open_roof"] = "included";
					const_var.insulationPriceJson.insulation_wall["storage_roof"] = "included";
				}
			}

			if (action.key == "p_l_w" && params.p_u_c) {
				const_var.insulationPriceJson.insulation_wall["storage_left"] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? "included" : false;
			}

			if (action.key == "p_r_w" && params.p_u_c) {
				const_var.insulationPriceJson.insulation_wall["storage_right"] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? "included" : false;
			}

			if (action.key == "p_b_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)) {
				const_var.insulationPriceJson.insulation_wall["storage_back"] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? "included" : false;
			}

			if (action.key == "p_f_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)) {
				const_var.insulationPriceJson.insulation_wall["storage_front"] = const_var.insulationPriceJson.insulation_wall[action.key] == true ? "included" : false;
			}
		}
		if (action.isfor != undefined && action.isfor == "frontLean" && const_var.leanGetDataFront) {
			if (const_var.insulationArrayForLeantoFront.insulation_wall == undefined) {
				const_var.insulationArrayForLeantoFront["insulation_wall"] = {};
			}
			const_var.insulationArrayForLeantoFront.insulation_wall[action.key] =
				const_var.insulationArrayForLeantoFront.insulation_wall &&
				const_var.insulationArrayForLeantoFront.insulation_wall[action.key] &&
				const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true
					? false
					: true;

			if (action.key == "p_b_c_b_f_l" && params.add_storage_check_front) {
				const_var.insulationArrayForLeantoFront.insulation_wall["storage_left"] = const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? "included" : false;
			}

			if (action.key == "full_roof" && params.add_storage_check_front) {
				const_var.insulationArrayForLeantoFront.insulation_wall["open_roof"] = const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? "included" : false;
				const_var.insulationArrayForLeantoFront.insulation_wall["storage_roof"] = const_var.insulationArrayForLeantoFront.insulation_wall[action.key] == true ? "included" : false;
			}
			if ((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check_front) {
				if (const_var.insulationArrayForLeantoFront.insulation_wall["open_roof"] == true && const_var.insulationArrayForLeantoFront.insulation_wall["storage_roof"] == true) {
					const_var.insulationArrayForLeantoFront.insulation_wall["full_roof"] = true;
					const_var.insulationArrayForLeantoFront.insulation_wall["open_roof"] = "included";
					const_var.insulationArrayForLeantoFront.insulation_wall["storage_roof"] = "included";
				}
			}
		}
		if (action.isfor != undefined && action.isfor == "backLean" && const_var.leanGetDataBack) {
			if (const_var.insulationArrayForLeantoBack.insulation_wall == undefined) {
				const_var.insulationArrayForLeantoBack["insulation_wall"] = {};
			}
			const_var.insulationArrayForLeantoBack.insulation_wall[action.key] =
				const_var.insulationArrayForLeantoBack.insulation_wall && const_var.insulationArrayForLeantoBack.insulation_wall[action.key] && const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true
					? false
					: true;

			if (action.key == "p_b_c_b_b_l" && params.add_storage_check_back) {
				const_var.insulationArrayForLeantoBack.insulation_wall["storage_right"] = const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? "included" : false;
			}

			if (action.key == "full_roof" && params.add_storage_check_back) {
				const_var.insulationArrayForLeantoBack.insulation_wall["open_roof"] = const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? "included" : false;
				const_var.insulationArrayForLeantoBack.insulation_wall["storage_roof"] = const_var.insulationArrayForLeantoBack.insulation_wall[action.key] == true ? "included" : false;
			}
			if ((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check_back) {
				if (const_var.insulationArrayForLeantoBack.insulation_wall["open_roof"] == true && const_var.insulationArrayForLeantoBack.insulation_wall["storage_roof"] == true) {
					const_var.insulationArrayForLeantoBack.insulation_wall["full_roof"] = true;
					const_var.insulationArrayForLeantoBack.insulation_wall["open_roof"] = "included";
					const_var.insulationArrayForLeantoBack.insulation_wall["storage_roof"] = "included";
				}
			}
		}
		if (action.isfor != undefined && action.isfor == "leftLean" && const_var.leanGetDataLeft) {
			if (const_var.insulationArrayForLeantoLeft.insulation_wall == undefined) {
				const_var.insulationArrayForLeantoLeft["insulation_wall"] = {};
			}
			const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] =
				const_var.insulationArrayForLeantoLeft.insulation_wall && const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] && const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true
					? false
					: true;

			if (action.key == "p_b_c_b_l" && params.add_storage_check) {
				const_var.insulationArrayForLeantoLeft.insulation_wall["storage_left"] = const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? "included" : false;
			}

			if (action.key == "full_roof" && params.add_storage_check) {
				const_var.insulationArrayForLeantoLeft.insulation_wall["open_roof"] = const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? "included" : false;
				const_var.insulationArrayForLeantoLeft.insulation_wall["storage_roof"] = const_var.insulationArrayForLeantoLeft.insulation_wall[action.key] == true ? "included" : false;
			}
			if ((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check) {
				if (const_var.insulationArrayForLeantoLeft.insulation_wall["open_roof"] == true && const_var.insulationArrayForLeantoLeft.insulation_wall["storage_roof"] == true) {
					const_var.insulationArrayForLeantoLeft.insulation_wall["full_roof"] = true;
					const_var.insulationArrayForLeantoLeft.insulation_wall["open_roof"] = "included";
					const_var.insulationArrayForLeantoLeft.insulation_wall["storage_roof"] = "included";
				}
			}
		}
		if (action.isfor != undefined && action.isfor == "rightLean" && const_var.leanGetDataRight) {
			if (const_var.insulationArrayForLeantoRight.insulation_wall == undefined) {
				const_var.insulationArrayForLeantoRight["insulation_wall"] = {};
			}
			const_var.insulationArrayForLeantoRight.insulation_wall[action.key] =
				const_var.insulationArrayForLeantoRight.insulation_wall &&
				const_var.insulationArrayForLeantoRight.insulation_wall[action.key] &&
				const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true
					? false
					: true;

			if (action.key == "p_b_c_b_r" && params.add_storage_check_right) {
				const_var.insulationArrayForLeantoRight.insulation_wall["storage_right"] = const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? "included" : false;
			}

			if (action.key == "full_roof" && params.add_storage_check_right) {
				const_var.insulationArrayForLeantoRight.insulation_wall["open_roof"] = const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? "included" : false;
				const_var.insulationArrayForLeantoRight.insulation_wall["storage_roof"] = const_var.insulationArrayForLeantoRight.insulation_wall[action.key] == true ? "included" : false;
			}
			if ((action.key == "open_roof" || action.key == "storage_roof") && params.add_storage_check_right) {
				if (const_var.insulationArrayForLeantoRight.insulation_wall["open_roof"] == true && const_var.insulationArrayForLeantoRight.insulation_wall["storage_roof"] == true) {
					const_var.insulationArrayForLeantoRight.insulation_wall["full_roof"] = true;
					const_var.insulationArrayForLeantoRight.insulation_wall["open_roof"] = "included";
					const_var.insulationArrayForLeantoRight.insulation_wall["storage_roof"] = "included";
				}
			}
		}
		state.const_var.UpdatedPriceData.insulation_price = undefined;
		state.const_var.UpdatedPriceData.insulation_price_changed = true;
		state.updateStateForlean = !state.updateStateForlean;
	}

	return {
		...state,
		action
	};
};
export const overHangCostTypeCalculation = {
	extraItemsFeaturesNonOverhang: extraItemsFeaturesNonOverhang,
	extraItemsFeaturesOverhangDoller: extraItemsFeaturesOverhangDoller,
	extraItemsFeaturesOverhangPer: extraItemsFeaturesOverhangPer,
	extraItemsFeaturesOverhangSQFT: extraItemsFeaturesOverhangSQFT
};
export const getMeDataForLean = (const_var, params, post_data, shouldCalculateForAllLean) => {
	let leanCertificatePrice = 0;

	post_data["building"].leanto = const_var.leanto;

	const individualPrice = {
		right: { leanPrice: 0, basePrice: 0, heightPrice: 0, dimension: 0, sideWallPrice: 0, endWallPrice: 0, allWallPrice: 0 },
		left: { leanPrice: 0, basePrice: 0, heightPrice: 0, dimension: 0, sideWallPrice: 0, endWallPrice: 0, allWallPrice: 0 },
		front: { leanPrice: 0, basePrice: 0, heightPrice: 0, dimension: 0, sideWallPrice: 0, endWallPrice: 0, allWallPrice: 0 },
		back: { leanPrice: 0, basePrice: 0, heightPrice: 0, dimension: 0, sideWallPrice: 0, endWallPrice: 0, allWallPrice: 0 }
	};

	if (post_data?.["building"]?.leanto?.length > 0) {
		for (var i = 0; i <= post_data["building"].leanto.length - 1; i++) {
			if (!shouldCalculateForAllLean) {
				if (const_var.isLTBuilding && post_data["building"].leanto[i].leanto_type !== LEAN_TYPE_STR_TO_NUM[const_var.selectedLeanType]) {
					continue;
				}
			}

			post_data["building"].leanto[i].porch = undefined;

			if (post_data["building"].leanto[i].leanto_type == 1) {
				post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentLeft];
				post_data["building"].leanto[i].total_length = params.lean_p_d;
				const_var.lengthData.leftLean.porchLength = 0;
				if (params.add_left_back_lean_porch == true) {
					post_data["building"].leanto[i].porch = {
						type: "left",
						length: params.lean_p_d + params.leanB_p_w,
						cost: parseInt(post_data["building"].connection_fee_left_back),
						wrap_with: ["back"]
					};
					post_data["building"].leanto[i].total_length = params.lean_p_d + params.leanB_p_w;
					const_var.lengthData.leftLean.porchLength = params.leanB_p_w;
				}
				if (params.add_left_front_lean_porch == true) {
					post_data["building"].leanto[i].porch = {
						type: "left",
						length: params.lean_p_d + params.leanF_p_w,
						cost: parseInt(post_data["building"].connection_fee_left_front),
						wrap_with: ["front"]
					};
					post_data["building"].leanto[i].total_length = params.lean_p_d + params.leanF_p_w;
					const_var.lengthData.leftLean.porchLength = params.leanF_p_w;
				}
				if (params.add_left_back_lean_porch == true && params.add_left_front_lean_porch == true) {
					post_data["building"].leanto[i].porch = {
						type: "left",
						length: params.lean_p_d + params.leanB_p_w + params.leanF_p_w,
						cost: parseInt(post_data["building"].connection_fee_left_front) + parseInt(post_data["building"].connection_fee_left_back),
						wrap_with: ["front", "back"]
					};
					post_data["building"].leanto[i].total_length = params.lean_p_d + params.leanF_p_w + params.leanB_p_w;
					const_var.lengthData.leftLean.porchLength = params.leanF_p_w + params.leanB_p_w;
				}
				if (params.p_e_i != "other" && params.p_e_i != "Select" && params.p_e_i != "") {
					if (post_data["building"].leanto[i].certificate_price && post_data["building"].leanto[i].certificate.name == const_var.c_f_aCer[params.p_e_i]?.name) {
						leanCertificatePrice = parseFloat(leanCertificatePrice) + parseFloat(post_data["building"].leanto[i].certificate_price);
					}
				}
			}
			if (post_data["building"].leanto[i].leanto_type == 2) {
				post_data["building"].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentRight];
				post_data["building"].leanto[i].total_length = params.leanR_p_d;
				const_var.lengthData.rightLean.porchLength = 0;
				if (params.add_right_back_lean_porch == true) {
					post_data["building"].leanto[i].porch = {
						type: "right",
						length: params.leanR_p_d + params.leanB_p_w,
						cost: parseInt(post_data["building"].connection_fee_right_back),
						wrap_with: ["back"]
					};
					post_data["building"].leanto[i].total_length = params.leanR_p_d + params.leanB_p_w;
					const_var.lengthData.rightLean.porchLength = params.leanB_p_w;
				}
				if (params.add_right_front_lean_porch == true) {
					post_data["building"].leanto[i].porch = {
						type: "right",
						length: params.leanR_p_d + params.leanF_p_w,
						cost: parseInt(post_data["building"].connection_fee_right_front),
						wrap_with: ["front"]
					};
					post_data["building"].leanto[i].total_length = params.leanR_p_d + params.leanF_p_w;
					const_var.lengthData.rightLean.porchLength = params.leanF_p_w;
				}
				if (params.add_right_back_lean_porch == true && params.add_right_front_lean_porch == true) {
					post_data["building"].leanto[i].porch = {
						type: "right",
						length: params.leanR_p_d + params.leanB_p_w + params.leanF_p_w,
						cost: parseInt(post_data["building"].connection_fee_right_front) + parseInt(post_data["building"].connection_fee_right_back),
						wrap_with: ["front", "back"]
					};
					post_data["building"].leanto[i].total_length = params.leanR_p_d + params.leanF_p_w + params.leanB_p_w;
					const_var.lengthData.rightLean.porchLength = params.leanF_p_w + params.leanB_p_w;
				}
				if (params.p_e_i != "other" && params.p_e_i != "Select" && params.p_e_i != "") {
					if (post_data["building"].leanto[i].certificate_price && post_data["building"].leanto[i].certificate.name == const_var.c_f_aCer[params.p_e_i]?.name) {
						leanCertificatePrice = parseFloat(leanCertificatePrice) + parseFloat(post_data["building"].leanto[i].certificate_price);
					}
				}
			}
			if (post_data["building"].leanto[i].leanto_type == 3) {
				post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentFront];
				post_data["building"].leanto[i].total_length = post_data["building"].leanto[i].length;
				if (post_data["building"].leanto[i].porch) {
					if (params.add_left_front_lean_porch == true) {
						post_data["building"].leanto[i].porch.wrap_with = ["left"];
					}
					if (params.add_right_front_lean_porch == true) {
						post_data["building"].leanto[i].porch.wrap_with = ["right"];
					}
					if (params.add_left_front_lean_porch == true && params.add_right_front_lean_porch == true) {
						post_data["building"].leanto[i].porch.wrap_with = ["left", "right"];
					}
				}
				if (params.p_e_i != "other" && params.p_e_i != "Select" && params.p_e_i != "") {
					if (post_data["building"].leanto[i].certificate_price && post_data["building"].leanto[i].certificate.name == const_var.c_f_aCer[params.p_e_i]?.name) {
						leanCertificatePrice = parseFloat(leanCertificatePrice) + parseFloat(post_data["building"].leanto[i].certificate_price);
					}
				}
			}
			if (post_data["building"].leanto[i].leanto_type == 4) {
				post_data["building"].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentBack];
				post_data["building"].leanto[i].total_length = post_data["building"].leanto[i].length;
				if (post_data["building"].leanto[i].porch) {
					if (params.add_left_back_lean_porch == true) {
						post_data["building"].leanto[i].porch.wrap_with = ["left"];
					}
					if (params.add_right_back_lean_porch == true) {
						post_data["building"].leanto[i].porch.wrap_with = ["right"];
					}
					if (params.add_left_back_lean_porch == true && params.add_right_back_lean_porch == true) {
						post_data["building"].leanto[i].porch.wrap_with = ["left", "right"];
					}
				}
				if (params.p_e_i != "other" && params.p_e_i != "Select" && params.p_e_i != "") {
					if (post_data["building"].leanto[i].certificate_price && post_data["building"].leanto[i].certificate.name == const_var.c_f_aCer[params.p_e_i]?.name) {
						leanCertificatePrice = parseFloat(leanCertificatePrice) + parseFloat(post_data["building"].leanto[i].certificate_price);
					}
				}
			}
			if (post_data["building"].leanto[i].leanto_type != 2 && post_data["building"].leanto[i].leanto_type != 1) {
				if (post_data["building"].leanto[i].porch) {
					post_data["building"].leanto[i].porch.cost = 0;
				}
			}

			const leanType = LEAN_TYPE_NUM_TO_STR[post_data["building"].leanto[i].leanto_type];

			const leanPrice = parseFloat(post_data["building"].leanto[i].t_c_b);
			individualPrice[leanType].leanPrice = leanPrice;

			const basePrice = parseFloat(post_data["building"].leanto[i].basic_price);
			individualPrice[leanType].basePrice = basePrice;

			const sideWallPrice = parseFloat(post_data["building"].leanto[i].side_wall_price);
			individualPrice[leanType].sideWallPrice = sideWallPrice;

			const endWallPrice = parseFloat(post_data["building"].leanto[i].front_wall_price) + parseFloat(post_data["building"].leanto[i].back_wall_price);
			individualPrice[leanType].endWallPrice = endWallPrice;

			let allWallPrice = sideWallPrice + endWallPrice;
			if (post_data["building"]?.leanto[i]?.utility_price) {
				allWallPrice += parseFloat(post_data["building"].leanto[i].utility_price);
			}
			individualPrice[leanType].allWallPrice = allWallPrice;

			const heightPrice = parseFloat(post_data["building"].leanto[i].height_price);
			individualPrice[leanType].heightPrice = heightPrice;

			const dimension = parseFloat(post_data["building"].leanto[i].width * post_data["building"].leanto[i].total_length);
			individualPrice[leanType].dimension = dimension;
		}
	}

	return { individualPrice };
};

export const prepareData = (val, params, const_var) => {
	if (val.name == undefined && val.sheet_name != undefined) {
		val["name"] = "overhang";
		val["label"] = val.sheet_name;
	}
	if (params.m_s_n == "122") {
		if (const_var.selSidingOption && const_var.selSidingOption == "board_and_batten_siding") {
			if (val.sheet_type == "side" && const_var.a_p_d_a.overhang?.side?.[0]?.is_included == 1) {
				val["is_included"] = false;
			}
			if (val.sheet_type == "end" && const_var.a_p_d_a.overhang?.end?.[0]?.is_included == 1) {
				val["is_included"] = false;
			}
			if (val.sheet_type == "both" && const_var.a_p_d_a.overhang?.both?.is_included == 1) {
				val["is_included"] = false;
			}
		} else {
			if (val.sheet_type == "side") {
				val["is_included"] = false;
			}
			if (val.sheet_type == "end") {
				val["is_included"] = false;
			}
			if (val.sheet_type == "both") {
				val["is_included"] = false;
			}
		}
	}
};

export const getPriceForExtraOptions = (const_var, params, post_data, extraItems, legacy_extra_items, UpdatePriceRecord, t_c) => {
	let totalPrice = 0;

	let fnToCalculatePrice = () => {};

	const theObject = const_var.isLTBuilding ? const_var.lNTBuildingData.ExtraItemsFeaturesArray : { centerBuilding: const_var.ExtraItemsFeaturesArray };

	Object.entries(theObject).forEach(([runningFor, theArray]) => {
		theArray.forEach((val, valIndex) => {
			if (val != null && val.name == undefined && val.sheet_name != undefined) {
				val["name"] = "overhang";
				val["label"] = val.sheet_name;
			}

			if (val?.["name"] === "overhang") {
				["left", "right", "front", "back"].map((leanto) => {
					const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanto].map((item, index) => {
						if (item) {
							if (valIndex === index) {
								item.label = val.label;
								item.name = val.name;
								item.is_edit = val.is_edit;
								if (item.sheet_name) {
									item.sheet_name = val.sheet_name;
								}
								if (item.sheet_type) {
									item.sheet_type = val.sheet_type;
								}
							}
						}
					});
				});
			}

			if (!(val != null && val.is_checked == true)) {
				return;
			}

			if (params.m_s_n == "122") {
				if (const_var.selSidingOption && const_var.selSidingOption.includes("board_and_batten")) {
					if (val.sheet_type == "side" && const_var.a_p_d_a.overhang.side?.[0]?.is_included == 1) {
						val["is_included"] = false;
					}
					if (val.sheet_type == "end" && const_var.a_p_d_a.overhang.end?.[0]?.is_included == 1) {
						val["is_included"] = false;
					}
					if (val.sheet_type == "both" && const_var.a_p_d_a.overhang.both?.[0]?.is_included == 1) {
						val["is_included"] = false;
					}
				} else {
					if (val.sheet_type == "side") {
						val["is_included"] = false;
					}
					if (val.sheet_type == "end") {
						val["is_included"] = false;
					}
					if (val.sheet_type == "both") {
						val["is_included"] = false;
					}
				}
			}

			if (val.name === "fourth_center_cost") {
				return;
			}

			const shouldCalculateAllLean = typeof val.sheet_name === "string" && val.sheet_name?.toLowerCase()?.includes("overhang");

			const { individualPrice } = getMeDataForLean(const_var, params, post_data, shouldCalculateAllLean);

			prepareData(val, params, const_var);

			let is_edit = UpdatePriceRecord == true && const_var.UpdatedPriceData["elements"]?.[val.label]?.is_edit;
			let itemPrice = is_edit ? const_var.UpdatedPriceData["elements"]?.[val.label]?.item_price : 0;

			if (const_var.isLTBuilding) {
				const key = val.name === "overhang" ? "centerBuilding" : runningFor;
				is_edit = UpdatePriceRecord == true && const_var.lNTBuildingData["updatePriceDataElements"][key]?.[val.label]?.is_edit;
				itemPrice = is_edit ? const_var.lNTBuildingData["updatePriceDataElements"][key]?.[val.label]?.item_price : 0;
			}

			itemPrice = parseFloat(itemPrice ?? 0);

			if (!is_edit) {
				if (val.name == "overhang") {
					if (val.is_included) {
						const pushableObject = {
							is_edit: false,
							item_name: val.label,
							other_item_name: val.name,
							item_quantity: parseInt(val.quantity),
							item_price: 0,
							LTPrice: 0,
							is_disabled: val.is_included || false
						};
						console.log(val, pushableObject, "pushableObject");
						if (runningFor === "centerBuilding") {
							legacy_extra_items.push(pushableObject);
						} else {
							extraItems[runningFor].push(pushableObject);
						}
						return;
					}

					if (runningFor === "centerBuilding") {
						let overhangPrice = 0;

						["centerBuilding", "left", "front", "back", "right"].forEach((leanType) => {
							if (leanType === "centerBuilding") {
								let centerBuildingPrice = 0;
								if (val.cost_type == "%") {
									centerBuildingPrice = overHangCostTypeCalculation.extraItemsFeaturesOverhangPer("centerBuilding", val, params, const_var, undefined, post_data, t_c);
								}
								if (val.cost_type == "$") {
									centerBuildingPrice = overHangCostTypeCalculation.extraItemsFeaturesOverhangDoller("centerBuilding", val, params, const_var);
								}
								if (val.cost_type == "sqft") {
									centerBuildingPrice = overHangCostTypeCalculation.extraItemsFeaturesOverhangSQFT("centerBuilding", val, params, const_var);
								}
								overhangPrice += centerBuildingPrice;
							} else {
								const valOfLean = const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType][valIndex];
								if (params[`add_${leanType}_lean`] && valOfLean) {
									let leanPrice = 0;
									if (valOfLean.cost_type == "%") {
										leanPrice = overHangCostTypeCalculation.extraItemsFeaturesOverhangPer(leanType, valOfLean, params, const_var, individualPrice[leanType], post_data, t_c);
									}
									if (valOfLean.cost_type == "$") {
										leanPrice = overHangCostTypeCalculation.extraItemsFeaturesOverhangDoller(leanType, valOfLean, params, const_var);
									}
									if (valOfLean.cost_type == "sqft") {
										leanPrice = overHangCostTypeCalculation.extraItemsFeaturesOverhangSQFT(leanType, valOfLean, params, const_var);
									}
									overhangPrice += leanPrice;
								}
							}
						});

						itemPrice = overhangPrice;
					}
				} else {
					fnToCalculatePrice = (module) => {
						if (module === "centerBuilding") {
							return parseFloat(val.cost);
						}
						return overHangCostTypeCalculation.extraItemsFeaturesNonOverhang(module, val, params, const_var);
					};

					if (const_var.isLTBuilding) {
						itemPrice = fnToCalculatePrice(runningFor);

						if (runningFor === "centerBuilding") {
							post_data.building?.leanto?.forEach((lean) => {
								if (lean.leanto_style === "standard") {
									itemPrice += fnToCalculatePrice(LEAN_TYPE_NUM_TO_STR[lean.leanto_type]);
								}
							});
						}
					} else {
						itemPrice = ["centerBuilding", "left", "front", "back", "right"].reduce((acc, curr) => acc + fnToCalculatePrice(curr), 0);
					}
				}
			}

			totalPrice += itemPrice;

			const pushableObject = {
				is_edit: is_edit,
				item_name: val.label,
				other_item_name: val.name,
				item_quantity: parseInt(val.quantity),
				item_price: itemPrice
			};

			if (const_var.inputs?.length > 0) {
				if (const_var.inputs?.length > 0) {
					let findCurrObj = const_var.inputs.findIndex((obj) => obj && obj.additional_name && obj.additional_name.trim().toLowerCase() == pushableObject.item_name.trim().toLowerCase());
					if (findCurrObj > -1) {
						const_var.inputs.splice(findCurrObj, 1);
					}
					if (runningFor === "centerBuilding") {
						if (legacy_extra_items.length > 0) {
							let checkForSameOption = legacy_extra_items.findIndex((obj) => obj?.item_name == pushableObject.item_name);
							if (checkForSameOption > -1) {
								legacy_extra_items.splice(checkForSameOption, 1);
							}
						}
					} else {
						if (extraItems[runningFor].length > 0) {
							let checkForSameOption = extraItems[runningFor].findIndex((obj) => obj?.item_name == pushableObject.item_name);
							if (checkForSameOption > -1) {
								extraItems[runningFor].splice(checkForSameOption, 1);
							}
						}
					}
				}
			}
			if (const_var.Componentinputs?.length > 0) {
				if (const_var.Componentinputs?.length > 0) {
					let findCurrObj = const_var.Componentinputs.findIndex((obj) => obj && obj.additional_name && obj.additional_name.trim().toLowerCase() == pushableObject.item_name.trim().toLowerCase());
					if (findCurrObj > -1) {
						const_var.Componentinputs.splice(findCurrObj, 1);
					}
					if (runningFor === "centerBuilding") {
						if (legacy_extra_items.length > 0) {
							let checkForSameOption = legacy_extra_items.findIndex((obj) => obj?.item_name == pushableObject.item_name);
							if (checkForSameOption > -1) {
								legacy_extra_items.splice(checkForSameOption, 1);
							}
						}
					} else {
						if (extraItems[runningFor].length > 0) {
							let checkForSameOption = extraItems[runningFor].findIndex((obj) => obj?.item_name == pushableObject.item_name);
							if (checkForSameOption > -1) {
								extraItems[runningFor].splice(checkForSameOption, 1);
							}
						}
					}
				}
			}
			if (val.name == "overhang") {
				legacy_extra_items.push(pushableObject);
			} else {
				if (runningFor === "centerBuilding") {
					legacy_extra_items.push(pushableObject);
				} else {
					extraItems[runningFor].push(pushableObject);
				}
			}
		});
	});

	post_data["building"].ExtraItemsFeaturesArray = const_var.isLTBuilding ? const_var.lNTBuildingData.ExtraItemsFeaturesArray["centerBuilding"] : const_var.ExtraItemsFeaturesArray;

	return convertToTwoDecimalNumber(totalPrice);
};
